module.exports = __webpack_public_path__ + "static/ICONS_CostSaving-a8e89ab7a916360f22d0d139a8236e3b.png";